














import { computed, defineComponent, PropType, ref } from '@nuxtjs/composition-api';
import SearchList from '@shared/components/SearchList/SearchList.vue';
import {
  autocompleteGetters,
  useAutocomplete,
} from '@unified-commerce/gpc-vue-storefront-google-places';

export interface ISearchListResult {
  label: string;
  value: string;
}

export default defineComponent({
  name: 'SuburbLookup',
  components: { SearchList },
  props: {
    onSubmit: {
      type: Function as PropType<(placeId: string) => void>,
      required: true,
    },
    onClear: {
      type: Function as PropType<() => void>,
      required: true,
    },
  },
  setup(props) {
    const autocomplete = useAutocomplete('search');
    const { getResults } = autocompleteGetters;
    const placeId = ref<string>('');

    const queryAddress = (searchValue: string) => autocomplete.query(searchValue);
    const onAddressSelected = (address: ISearchListResult) => {
      placeId.value = address.value;
      props.onSubmit(placeId.value);
    };
    const inputCleared = () => {
      placeId.value = '';
      props.onClear();
    };

    const errorMessage = computed(() => autocomplete.error.value?.message);
    const results = computed(() =>
      autocomplete.result?.value ? getResults(autocomplete.result.value) : [],
    );

    return {
      autocomplete,
      errorMessage,
      results,
      inputCleared,
      queryAddress,
      onAddressSelected,
    };
  },
});
